import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, Suspense as _Suspense, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2263fd72"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "choice-table-content" }
const _hoisted_2 = {
  class: "flex-ter table-th",
  style: {top: '252px'}
}
const _hoisted_3 = { class: "check-box" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "action" }
const _hoisted_9 = { class: "table-shop" }
const _hoisted_10 = {
  key: 0,
  class: "check-box flex-ter",
  style: {"width":"100%"}
}
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  key: 1,
  class: "disabled-title flex"
}
const _hoisted_13 = {
  key: 0,
  class: "fx-1"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "tr-check-box" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "line--2" }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = {
  key: 2,
  class: "goods-props"
}
const _hoisted_21 = { style: {"width":"200px"} }
const _hoisted_22 = {
  class: "line--2",
  style: {"box-sizing":"border-box","padding":"0 5px"}
}
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { key: 1 }
const _hoisted_25 = {
  key: 3,
  class: "rel"
}
const _hoisted_26 = {
  key: 0,
  class: "abs rp-color not-enough",
  style: {"top":"35px","color":"#FE2C55","width":"170px","left":"-15px"}
}
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = {
  class: "primary",
  style: {"padding":"10px 0","color":"#333333","max-width":"200px"}
}
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = {
  key: 1,
  style: {"color":"#FE2C55"}
}
const _hoisted_33 = { key: 0 }
const _hoisted_34 = {
  key: 1,
  style: {"color":"#FE2C55"}
}
const _hoisted_35 = { key: 2 }
const _hoisted_36 = {
  key: 6,
  style: {"color":"#FE2C55"}
}
const _hoisted_37 = { class: "line--3" }
const _hoisted_38 = { style: {"max-width":"300px"} }
const _hoisted_39 = { class: "text-ct rel" }
const _hoisted_40 = { class: "fx-1 action" }
const _hoisted_41 = {
  key: 0,
  class: "no-price-tip"
}

import { QuestionFilled } from '@element-plus/icons-vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { formatMoney } from '@/plugins/utils'
import { isJA, isWhiteHiddenRMB } from '@/store'
import LogoIcon from '@/components/common/LogoIcon.vue'
import { t } from '@/plugins/i18n'
import { tableColumns } from './data'
import QuestionMark from '@/components/IconPark/QuestionMark.vue'
import { goodsPropName } from '@/util/useFormat'
import { ref, watch, computed } from 'vue'
import AmountSet from '../AmountSet.vue'
import ChangeSku from '../ChangeSku.vue'
import AllPriceDetail from './AllPriceDetail.vue'
import { addAdt, changeMSku, changeSkuNum, deleteSku } from '@/apis/shopcart'
import { montageAddition } from '@/util/calcAdt'
import AdditionDrawer from '@/components/additional/AdditionDrawer.vue'
import Empty from '../Empty.vue'
import { confirmDeleteSku } from '@/util/useConfirm'
import { liveGoods } from '@/common/const'
import { useStore } from 'vuex'

export default /*#__PURE__*/_defineComponent({
  props: ['list', 'choiceFn', 'normalDisabled', 'transportType', 'isTikTokShop2C'],
  emits: ['update', 'refresh', 'checkStatus'],
  setup(__props, { emit }) {

const props = __props

const goods: any = ref({ orderQuantity: 1, notInStorage: 0 })

const allCheck = ref(false)
const mustAdditionId = ref([])
const proxy: any = ref({
  cartAdditionList: null
})
const store = useStore()
const supportLiveDevice = computed(() => store.getters.shopInfo?.supportLiveDevice)

const ntableColumns = computed(() => {
  return !supportLiveDevice.value ? tableColumns : tableColumns?.filter(i => i.name !== 'priceType')
})

const changeCustomerSku = (goods: any) => {
  changeMSku(goods).then((res) => {
  })
}
const handleAdt = (t: any, cartId = proxy.value.cartId, goods = proxy) => {
  const cartAdditionList = Array.isArray(t) ? t : []
  const noAdditionalFlag = t === 1 ? t : 0
  addAdt({
    cartId,
    cartAdditionList,
    noAdditionalFlag
  }).then(() => {
    emit('refresh')
    emit('checkStatus', 4)
  })
}
const changeShopBox = (item: any) => {
  item.cartList.forEach((cartItem: any) => {
    cartItem.check = item.allCheck
  })
}
const changeSkuBox = (item: any) => {
  item.allCheck = item.cartList.every(v => v.check)
}
const changeAllCheck = (check: boolean) => {
  console.log(check)
  props.list.forEach((item: any) => {
    if (item.disabled) return
    item.allCheck = check
    item.cartList.forEach((temp: any) => {
      temp.check = check
    })
  })
}
watch(() => props.list, () => {
  allCheck.value = props.list?.length > 0 && props.list.filter(v => !v.disabled).every(v => v.allCheck)
}, {
  deep: true
})
const goodsList = computed(() => {
  const list = [...props.list]
  list.forEach((item) => {
    item.cartList?.forEach(async (temp: any) => {
      temp.priceType = (await props.choiceFn.getPriceTypeInfo(temp.season))?.name
    })
  })
  return list
})
let timer: any = null
let old = 0
const handleChange = (num: number, goods: any) => {
  goods.orderQuantity = num
  if (timer) {
    clearTimeout(timer)
    timer = null
  } else {
    old = goods.orderQuantity
  }
  timer = setTimeout(() => {
    changeSkuNum({ cartId: goods.cartId, orderQuantity: num }).then((res) => {
      if (res.success) {
        emit('refresh')
      } else {
        goods.orderQuantity = old
      }
    })
  }, 500)
}

const handleDel = (goods: { cartId: string }) => {
  confirmDeleteSku(
    () => {
      deleteSku({ cartIdList: [goods.cartId] }).then(() => {
        emit('refresh')
      })
    },
    () => { }
  )
}
const editAddition = (temp: any) => {
  console.log(temp.category?.needAdditionList)
  proxy.value = {
    ...temp,
    cartAdditionList: temp.cartAdditionList ?? []
  }
  mustAdditionId.value = temp.category?.needAdditionList ?? []
}
const jump = (item: any) => {
  if (isWhiteHiddenRMB() && liveGoods.includes(item.productCode)) {
    window.location.href = `/ja/goods/${item.productCode}`
    return
  }
  window.location.href = '/choice/' + item.productCode
}
const choiceTip = () => {
  if (props.isTikTokShop2C) {
    ElMessage.warning(t('choice商品暂不支持tiktok店铺'))
    return
  }
  if (props.normalDisabled) {
    ElMessage.warning(t('购物车代采商品和一口价商品不支持一起递交订单付款，请您按照商品类型依次提交订单完成付款操作'))
    return
  }
  emit('checkStatus', 3)
}
const clearInvalGoods = (item: any) => {
  ElMessageBox.confirm(t('是否清空失效商品'), t('提示'), {
    confirmButtonText: t('确定'),
    cancelButtonText: t('取消'),
    type: 'warning'
  }).then(() => {
    deleteSku({ cartIdList: item.cartList.map(v => v.cartId) }).then(() => {
      emit('refresh')
    })
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_radio = _resolveComponent("el-radio")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_checkbox, {
            label: _unref(t)('全选'),
            modelValue: allCheck.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((allCheck).value = $event)),
            indeterminate: __props.list.filter(v => !v.disabled).some(v => v.allCheck) && !__props.list.filter(v => !v.disabled).every(v => v.allCheck),
            onChange: _cache[1] || (_cache[1] = (e) => changeAllCheck(e)),
            disabled: __props.normalDisabled,
            onClick: _withModifiers(choiceTip, ["stop"])
          }, null, 8, ["label", "modelValue", "indeterminate", "disabled", "onClick"])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ntableColumns), (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            style: _normalizeStyle({ width: item.width + 'px' })
          }, [
            (item.name === 'customSku')
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                  _createTextVNode(_toDisplayString(item.label) + " ", 1),
                  _createVNode(_component_el_tooltip, {
                    effect: "light",
                    placement: "top",
                    "popper-class": "tool-tip-no-border"
                  }, {
                    content: _withCtx(() => [
                      _createElementVNode("div", {
                        style: _normalizeStyle({ maxWidth: _unref(isJA)() ? '520px' : '300px' })
                      }, [
                        _createElementVNode("div", {
                          innerHTML: _unref(t)('商品SKU作用旨在区分相同商品的不同规格、尺寸、颜色等。')
                        }, null, 8, _hoisted_5),
                        _createElementVNode("div", {
                          innerHTML: _unref(t)('您可以直接填写自家店铺现有的的商品SKU，也可以额外设置新的SKU。')
                        }, null, 8, _hoisted_6)
                      ], 4)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(QuestionMark, {
                        size: 14,
                        color: "#000000A6"
                      })
                    ]),
                    _: 1
                  })
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(item.label), 1))
          ], 4))
        }), 128)),
        _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(t)('操作')), 1)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(goodsList), (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "flex-ter table-body",
          key: index
        }, [
          _createElementVNode("div", _hoisted_9, [
            (!item.disabled)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createVNode(_component_el_checkbox, {
                    style: {"margin-right":"32px"},
                    modelValue: item.allCheck,
                    "onUpdate:modelValue": ($event: any) => ((item.allCheck) = $event),
                    onChange: ($event: any) => (changeShopBox(item)),
                    indeterminate: item.cartList?.some(v => v.check) && !item.cartList.every(v => v.check),
                    disabled: item.disabled || __props.normalDisabled,
                    onClick: _withModifiers(choiceTip, ["stop"])
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange", "indeterminate", "disabled", "onClick"]),
                  (item.cartList?.some(v => v.choiceFlag))
                    ? (_openBlock(), _createBlock(LogoIcon, {
                        key: 0,
                        type: "choice"
                      }))
                    : _createCommentVNode("", true),
                  (!item.cartList?.some(v => v.channel === 5))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(item.cartGroupName), 1))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("span", null, _toDisplayString(item.cartGroupName), 1),
                  (item.invalidGoods)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createElementVNode("span", {
                          class: "inval",
                          onClick: ($event: any) => (clearInvalGoods(item))
                        }, _toDisplayString(_unref(t)('清空失效商品')), 9, _hoisted_14)
                      ]))
                    : _createCommentVNode("", true)
                ])),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.cartList, (temp, k) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: k }, [
                _createElementVNode("div", {
                  class: "table-tr flex-ter",
                  style: _normalizeStyle({ opacity: item.invalidGoods ? '0.5' : '' })
                }, [
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_el_checkbox, {
                      modelValue: temp.check,
                      "onUpdate:modelValue": ($event: any) => ((temp.check) = $event),
                      onChange: ($event: any) => (changeSkuBox(item)),
                      disabled: item.disabled || __props.normalDisabled,
                      onClick: _withModifiers(choiceTip, ["stop"])
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange", "disabled", "onClick"])
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ntableColumns), (tableItem, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      style: _normalizeStyle({ width: (tableItem.trWidth ?? tableItem.width) + 'px' }),
                      class: "table-td"
                    }, [
                      (tableItem.name === 'title')
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "title flex-ter cursor-pt",
                            onClick: ($event: any) => (jump(temp))
                          }, [
                            _createElementVNode("img", {
                              src: temp.productSkuImg ?? temp.productMainImg,
                              alt: ""
                            }, null, 8, _hoisted_17),
                            _createElementVNode("span", _hoisted_18, _toDisplayString(temp.productTitleJp), 1)
                          ], 8, _hoisted_16))
                        : _createCommentVNode("", true),
                      (tableItem.name === 'customSku')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                            _createVNode(_component_el_input, {
                              modelValue: temp.customerProductMsku,
                              "onUpdate:modelValue": ($event: any) => ((temp.customerProductMsku) = $event),
                              onBlur: ($event: any) => (changeCustomerSku(temp)),
                              disabled: item.disabled
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur", "disabled"])
                          ]))
                        : _createCommentVNode("", true),
                      (tableItem.name === 'sku')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                            (temp.productPropertiesName)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(goodsPropName)(temp), (v) => {
                                    return (_openBlock(), _createElementBlock("div", { key: v }, [
                                      _createVNode(_component_el_tooltip, {
                                        effect: "light",
                                        placement: "top"
                                      }, {
                                        content: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_21, _toDisplayString(v?.replace('颜色', '色')?.replace('尺码', 'サイズ')), 1)
                                        ]),
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_22, _toDisplayString(v?.replace('颜色', '色')?.replace('尺码', 'サイズ')), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]))
                                  }), 128)),
                                  (temp.notInStorage === 0 && !item.disabled)
                                    ? (_openBlock(), _createBlock(ChangeSku, {
                                        key: 0,
                                        data: temp,
                                        onUpdate: _cache[2] || (_cache[2] = ($event: any) => (emit('refresh')))
                                      }, {
                                        default: _withCtx(() => [
                                          (temp.productType === 1)
                                            ? (_openBlock(), _createElementBlock("label", {
                                                key: 0,
                                                class: "btn primary-color",
                                                onClick: ($event: any) => (temp.replace = true),
                                                style: {"color":"#0586FE"}
                                              }, _toDisplayString(_unref(t)('变更')), 9, _hoisted_23))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 2
                                      }, 1032, ["data"]))
                                    : _createCommentVNode("", true)
                                ], 64))
                              : (_openBlock(), _createElementBlock("span", _hoisted_24, "-"))
                          ]))
                        : _createCommentVNode("", true),
                      (tableItem.name === 'amount')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                            (temp.notInStorage === 0 && !item.disabled)
                              ? (_openBlock(), _createBlock(AmountSet, {
                                  amount: temp.orderQuantity,
                                  min: 1,
                                  goods: temp,
                                  "onUpdate:amount": (e) => handleChange(e, temp),
                                  key: temp.orderQuantity,
                                  hiddenLadder: true
                                }, {
                                  default: _withCtx(() => [
                                    (temp.check && (__props.choiceFn.getCartIdLackStatus(temp)?.lack || __props.choiceFn.getCartIdLackStatus(temp)?.goodsLack))
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                          (__props.choiceFn.getCartIdLackStatus(temp)?.goodsLack)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_unref(t)('购买数量不可低于X件').replace('X',
                        __props.choiceFn.getCartIdLackStatus(temp)?.minQuantity)), 1))
                                            : (__props.choiceFn.getCartIdLackStatus(temp)?.lack)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_28, [
                                                  _createElementVNode("span", null, _toDisplayString(temp.category?.categoryNameJp), 1),
                                                  _createTextVNode(" " + _toDisplayString(_unref(t)('同一订单X件起批或搭配其他类购买').replace('X',
                          __props.choiceFn.getCartIdLackStatus(temp)?.minQuantity)) + " ", 1),
                                                  _createVNode(_component_el_tooltip, {
                                                    placement: "top",
                                                    effect: "light",
                                                    "popper-class": "tool-tip-no-border",
                                                    offset: 10
                                                  }, {
                                                    content: _withCtx(() => [
                                                      _createElementVNode("div", _hoisted_29, _toDisplayString(_unref(t)('※同一笔订单任意商品满足起订数量后，其他商品也可一并购买。')), 1)
                                                    ]),
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_el_icon, { style: {"vertical-align":"middle","cursor":"pointer"} }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_unref(QuestionFilled))
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  })
                                                ]))
                                              : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1032, ["amount", "goods", "onUpdate:amount"]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(temp.orderQuantity), 1))
                          ]))
                        : _createCommentVNode("", true),
                      (tableItem.name === 'priceType')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                            (temp.priceType)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(temp.priceType), 1))
                              : (_openBlock(), _createElementBlock("div", _hoisted_32, "/"))
                          ], 64))
                        : _createCommentVNode("", true),
                      (tableItem.name === 'allPrice')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                            (temp.allIncludePriceResult?.allIncludeProductPriceExchange)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(_unref(formatMoney)(temp.allIncludePriceResult?.allIncludeProductPriceExchange) || '-'), 1))
                              : (!item.invalidGoods)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString(_unref(t)('一口价无法计算')), 1))
                                : _createCommentVNode("", true),
                            (item.invalidGoods)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_35, "-"))
                              : _createCommentVNode("", true),
                            (temp.allIncludePriceResult?.allIncludeProductPriceExchange && temp.switchAllIncludePriceJp != 1)
                              ? (_openBlock(), _createBlock(AllPriceDetail, {
                                  key: 3,
                                  detail: temp.allIncludePriceResult,
                                  season: temp.season,
                                  transportType: __props.transportType
                                }, null, 8, ["detail", "season", "transportType"]))
                              : _createCommentVNode("", true)
                          ], 64))
                        : _createCommentVNode("", true),
                      (tableItem.name === 'totalPrice')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(_unref(formatMoney)(temp.allIncludePriceResult?.allIncludeProductTotalPriceExchange) || '-'), 1))
                        : _createCommentVNode("", true),
                      (tableItem.name === 'adt')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                            (temp.additionNameJpSummary)
                              ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                  key: 0,
                                  placement: "top",
                                  effect: "light"
                                }, {
                                  content: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_38, _toDisplayString(_unref(montageAddition)(temp.cartAdditionList)), 1)
                                  ]),
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_37, _toDisplayString(_unref(montageAddition)(temp.cartAdditionList)), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true),
                            (!item.disabled && !_unref(isWhiteHiddenRMB)())
                              ? (_openBlock(), _createBlock(_component_el_button, {
                                  key: 1,
                                  type: "text",
                                  style: {"color":"#0586FE"},
                                  onClick: ($event: any) => (editAddition(temp))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(t)('编辑')), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_39, [
                              _withDirectives(_createVNode(_component_el_radio, {
                                "model-value": !!temp.noAdditionalFlag,
                                size: "small",
                                label: true,
                                style: {"margin-right":"0"},
                                onChange: ($event: any) => (handleAdt(1, temp.cartId)),
                                disabled: item.disabled
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(t)('不需要检品')), 1)
                                ]),
                                _: 2
                              }, 1032, ["model-value", "onChange", "disabled"]), [
                                [_vShow, !temp.cartAdditionList?.length]
                              ]),
                              _withDirectives(_createElementVNode("div", { class: "abs add-valid-text" }, _toDisplayString(_unref(t)('附加项验证')), 513), [
                                [_vShow, !(temp.cartAdditionList?.length || temp.noAdditionalFlag) && !item.disabled]
                              ])
                            ])
                          ], 64))
                        : _createCommentVNode("", true)
                    ], 4))
                  }), 128)),
                  _createElementVNode("div", _hoisted_40, [
                    _createVNode(_component_el_button, {
                      type: "text",
                      style: {"color":"#0586FE"},
                      onClick: ($event: any) => (handleDel(temp))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('删除')), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ])
                ], 4),
                (!temp.allIncludePriceResult?.allIncludeProductPriceExchange && item.noPriceType)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_41, _toDisplayString(_unref(t)('计价规格缺失，如需按照一口价购买商品，请联系业务补充')), 1))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ])
        ]))
      }), 128)),
      (__props.list.length === 0)
        ? (_openBlock(), _createBlock(Empty, { key: 0 }))
        : _createCommentVNode("", true)
    ]),
    (_openBlock(), _createBlock(_Suspense, null, {
      default: _withCtx(() => [
        (proxy.value.cartAdditionList)
          ? (_openBlock(), _createBlock(AdditionDrawer, {
              key: 0,
              list: proxy.value.cartAdditionList,
              "onUpdate:list": _cache[3] || (_cache[3] = ($event: any) => ((proxy.value.cartAdditionList) = $event)),
              proxy: proxy.value,
              countryCode: "CN",
              onCommit: handleAdt,
              type: "AdtOrder",
              title: _unref(t)('商品オプション設定'),
              isConfirmKey: true,
              choiceCost: true,
              noSpot: true,
              hiddenRMB: _unref(isWhiteHiddenRMB)
            }, null, 8, ["list", "proxy", "title", "hiddenRMB"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }))
  ], 64))
}
}

})